module.exports = __webpack_public_path__ + "img/balloon.f764a3f3.png";